import React from 'react';
import { AddOn, AddOnChannels } from 'common/modules/plans';
import ContainerBox from 'components/ContainerBox';
import AddOnModalContent from 'components/modals/AddOnModalContent';
import { useLocation } from 'react-router';

export interface AddOnPromoPageProps {
	addOn: AddOn;
}
const AddOnPromoPage = (props: AddOnPromoPageProps) => {
	const { addOn } = props;
	const location = useLocation();

	return (
		<ContainerBox padding="none">
			<AddOnModalContent
				addOn={addOn}
				addOnChannel={AddOnChannels.promo_page}
				onClose={() => {}}
				nextRoute={location.pathname}
				dividerType="divider"
			/>
		</ContainerBox>
	);
};

export default AddOnPromoPage;
